module.exports = __webpack_public_path__ + "static/img/star-important@2x.1d63e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/star-important@2x.png
// module id = pZ43
// module chunks = 1